"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/core-js/modules/es6.array.iterator.js");
require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/core-js/modules/es6.promise.js");
require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/core-js/modules/es6.object.assign.js");
require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/core-js/modules/es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
require("./styles/element-variables.scss");
require("@/styles/index.scss");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
var _index2 = _interopRequireDefault(require("./http/index"));
require("babel-polyfill");
var _es6Promise2 = _interopRequireDefault(require("es6-promise"));
var _lang = _interopRequireDefault(require("./lang"));
require("./icons");
require("./permission");
require("./utils/error-log");
var filters = _interopRequireWildcard(require("./filters"));
require("./components/Common/loadComponent");
var _functionsPermission = _interopRequireDefault(require("./directive/functionsPermission"));
var _amfeFlexible = _interopRequireDefault(require("amfe-flexible"));
require("viewerjs/dist/viewer.css");
var _vViewer = _interopRequireDefault(require("v-viewer"));
var _vueSimpleSpinner = _interopRequireDefault(require("vue-simple-spinner"));
// a modern alternative to CSS resets

// global css

// import 'default-passive-events'

/* 兼容IE */
_es6Promise2.default.polyfill();

// internationalization
// icon
// permission control
// error log

// global filters

// 加载不需要每个页面都引入组件

// 按钮权限控制指令

// import { mockXHR } from '../mock'
// mockXHR()

_vue.default.use(_amfeFlexible.default);

/* label view */

_vue.default.use(_vViewer.default);
_vue.default.use(_index2.default);
_vue.default.use(_functionsPermission.default);
_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'mini',
  // set element-ui default size
  i18n: function i18n(key, value) {
    return _lang.default.t(key, value);
  }
});

// loading组件

_vue.default.component('vue-simple-spinner', _vueSimpleSpinner.default);

// register global utility filters
Object.keys(filters).forEach(function (key) {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;

// 百度地图异步加载回调处理
window.onBMapCallback = function () {
  console.log('百度地图脚本初始化成功...');
};
// 插入百度地图script脚本
var scriptNode = document.createElement('script');
scriptNode.setAttribute('type', 'text/javascript');
scriptNode.setAttribute('src', 'https://api.map.baidu.com/api?v=3.0&&type=webgl&ak=' + process.env.VUE_APP_BAIDU_MAP_KEY + '&s=1&callback=onBMapCallback');
document.body.appendChild(scriptNode);
var _default = exports.default = new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: function render(h) {
    return h(_App.default);
  }
});